"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguageSwitcher = void 0;
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const languages_adapt_1 = require("../adaptors/languages-adapt");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const useLanguageSwitcher = () => {
    const { i18n, t } = (0, react_i18next_1.useTranslation)();
    const languages = (0, react_1.useMemo)(() => (0, languages_adapt_1.languagesAdapt)(t, constants_1.availableLanguages), [constants_1.availableLanguages, i18n.language]);
    const changeLanguage = (0, react_1.useCallback)((lang) => {
        i18n.changeLanguage(lang);
        (0, utils_1.dispatchLanguage)(lang);
    }, [i18n.language]);
    return {
        languages,
        changeLanguage,
    };
};
exports.useLanguageSwitcher = useLanguageSwitcher;
//# sourceMappingURL=use-language-switcher.js.map